import { render, staticRenderFns } from "./ProtocolSkipAndConfirm.vue?vue&type=template&id=c7a847b0&"
import script from "./ProtocolSkipAndConfirm.vue?vue&type=script&lang=js&"
export * from "./ProtocolSkipAndConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports